"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToActionsInModal = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Website_1 = __importDefault(require("../../../common/components/CallToActions/Website"));
const CallToActionItemNew_1 = __importDefault(require("./CallToActionItemNew"));
const CallToActionsWrapper = styled_components_1.default.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  gap: 5px;
  padding: 12px 0 8px;
  font-size: 0.9rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  ul {
    padding: 0 !important;
  }

  &.bareiss {
    width: calc(100% + 40px) !important;
    position: relative;
    left: -20px;

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: ${() => "url( /images/other/bareissPngWide.png )"};
  }
`;
const CallToActionsInModal = (props) => {
    const { activeItem, openMap, openEmail, openPhone, venue } = props;
    const { content } = activeItem;
    const actions = ["phone", "email", "website", "lat"];
    const availableActions = actions.reduce((acc, curr) => {
        if (content[curr]) {
            return [...acc, { [curr]: content[curr] }];
        }
        return [...acc];
    }, []);
    if (!availableActions.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const getRenderContainer = (type = "circle") => ({
        email: (react_1.default.createElement(CallToActionItemNew_1.default, { onClick: () => {
                if (openEmail) {
                    openEmail();
                }
            }, activeItem: activeItem, key: "email", icon: "email", destination: "email", text: i18n_js_1.default.t("tab_email") })),
        website: (react_1.default.createElement(Website_1.default, { key: "website", url: content.website, type: type, text: (content === null || content === void 0 ? void 0 : content.websiteLabel) || i18n_js_1.default.t("website") })),
        phone: (react_1.default.createElement(CallToActionItemNew_1.default, { onClick: () => {
                if (openPhone) {
                    openPhone();
                }
            }, activeItem: activeItem, key: "call", icon: "call", destination: "call", text: i18n_js_1.default.t("tab_call") })),
        lat: (react_1.default.createElement(CallToActionItemNew_1.default, { onClick: openMap, activeItem: activeItem, key: "map", icon: "map", destination: "map", text: i18n_js_1.default.t("map") })),
    });
    const renderCallToActions = () => {
        const renderContainer = getRenderContainer();
        return availableActions.map((availableAction) => {
            const actionType = Object.keys(availableAction)[0];
            return renderContainer[actionType];
        });
    };
    const bareissClass = venue && venue.brandSlug === "bareiss" ? "bareiss" : "";
    return (react_1.default.createElement(CallToActionsWrapper, { className: `call-to-actions ${bareissClass}` }, renderCallToActions()));
};
exports.CallToActionsInModal = CallToActionsInModal;
const mapStoreToProps = (store) => ({
    venue: store.getValue("venue"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.CallToActionsInModal);
